import React from 'react';
import "./card.css";
import { AiOutlineRight } from "react-icons/ai";

/*
  The one card every list page renders. There used to be five near-identical
  components (CVEButton, CertificationButton, WorkshopButton, WriteupButton,
  ProjectButton) that each rebuilt the same markup with slightly different
  spacing, which is how the pages drifted apart.

  layout  "row"   media/icon on the left, chevron on the right   (default)
          "stack" media on top, content under it, footer at the bottom
  to      an external url. Without one the card is static: no chevron, no hover.
*/
const Card = ({
  to = "",
  layout = "row",
  media = null,
  icon = null,
  title,
  badges = null,
  meta = null,
  description = null,
  action = "",
  footer = null,
}) => {

  const linked = to !== "";
  const stacked = layout === "stack";
  const cls = ["card", stacked ? "stack fss" : "row fcb", linked ? "" : "static"]
    .filter(Boolean)
    .join(" ");

  const body = (
    <>
      {media}
      <div className="main fcs">
        {icon}
        <div className="body fss">
          <div className="heading fcs">
            <span className="d-text title">{title}</span>
            {badges}
          </div>
          {meta && <div className="meta fcs">{meta}</div>}
          {description && <div className="d-text description">{description}</div>}
        </div>
      </div>
      {
        (footer || action) &&
        <div className="foot fcb">
          <div className="foot-left fcs">{footer}</div>
          {action && <span className="action fcs">{action}<AiOutlineRight className="arrow" /></span>}
        </div>
      }
      {linked && !stacked && <AiOutlineRight className="arrow" />}
    </>
  );

  if (!linked) return <div className={cls}>{body}</div>;

  return (
    <a className={cls} href={to} target="_blank" rel="noopener noreferrer">
      {body}
    </a>
  )
}

export default Card
